import { SECOND_ATTEMPT_BULK_INVALIDATION_MODAL } from '../../actionTypes/reading/apiActionTypes';

export const showSecondAttemptBulkInvalidationModal = studentInfo => ({
    type: SECOND_ATTEMPT_BULK_INVALIDATION_MODAL.SHOW,
    studentInfo,
});

export const hideSecondAttemptBulkInvalidationModal = () => ({
    type: SECOND_ATTEMPT_BULK_INVALIDATION_MODAL.HIDE,
    studentInfo: null,
});
